import Panel from './Panel.js';

/**
 * RichTextPanel class.
 */
export default class RichTextPanel extends Panel {
  maxDistance = 100;

  static config = {
    name: 'RichTextPanel',
  };
}
